<template>
  <div class="video-scroll-container" ref="video-scroll-container">
    <div class="video-player" :id="`container_${uniqVideoId}`" :ref="uniqVideoId">
      <VideoMcpViewer :mcp-id="mcpId" :video-uniq-id="uniqVideoId" :play-video="playVideo" class="container-video-multimedia" />
    </div>
  </div>
</template>

<style lang="scss"> 
  .video-scroll-container {
    position: relative;
    width: 100%;
    height: 170vh;
    background: #000;

    .video-player {
      position: sticky;
      top: 0;
      width: 100%;
      height: 100vh;
    }

    .jwplayer {
      position: sticky;
      top: 0;
    }
  }
</style>

<script>

  import VideoMcpViewer from '@/components/VideoMcpViewer.vue'

  export  default {
    name: 'VideoScroll',
    props: {
      mcpId: {
        type: String,
        default: ``
      }
    },
    data() {
      return {
        playVideo: false,
        uniqVideoId: `component_video_${this._uid}`
      }
    },
    components: {
      VideoMcpViewer
    },
    mounted() {
       window.addEventListener('scroll', () => {
          const parent = this.$refs['video-scroll-container'].offsetTop

          //const offsetTop = this.$refs[this.uniqVideoId].offsetTop

          const offsetHeight = this.$refs['video-scroll-container'].offsetHeight

          const top = parent

          const end = parent + offsetHeight

          if((window.scrollY <= (end - 350) && window.scrollY >= top) && !this.playVideo) {
            this.playVideo = !this.playVideo
          } else {
            if(((window.scrollY >= top && window.scrollY <= (end - 350))) && this.playVideo) {
              if(window.scrollY<= (top - 350)) {
                this.playVideo = false
              }
            } else {
              this.playVideo = false
            }
          }
       })
    }
  }

</script>